import { observer } from 'mobx-react-lite';

import { ETariffProfileRuleType } from '../../../core/tariff-profile';
import { DataGridTariffRow } from './create-table-grid-data';
import { useCellEditor } from './edit-cell-provider';
import { ERuleValueType } from './types';
import { detectRuleValue, ruleTypeMapIcons } from './utils';

type TariffPriceCellProps = {
  row: DataGridTariffRow;
  zoneId: number;
};

const valueTypeMap: Record<ERuleValueType, string> = {
  [ERuleValueType.amount]: '֏',
  [ERuleValueType.percent]: '%',
};

const TypeIcon = observer(({ type }: { type: ETariffProfileRuleType }) => {
  const Icon = ruleTypeMapIcons[type];
  return <Icon />;
});

export const TariffProfileCell = observer(
  ({ row, zoneId }: TariffPriceCellProps) => {
    const callEditor = useCellEditor();
    const tariffProfile = callEditor.dataMap.getRecord({
      tariffTypeId: row.tariffTypeId,
      terminalTypeId: row.terminalTypeId,
      zoneId,
    });

    if (!tariffProfile) return null;

    const { value, valueType } = detectRuleValue(tariffProfile);
    const type = tariffProfile.rule?.type;

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span>
          {value} {valueType && <span>{valueTypeMap[valueType]}</span>}
        </span>

        {type !== undefined && type !== null && <TypeIcon type={type} />}
      </div>
    );
  },
);
